import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  Table, TableHeader, TableRow, TableHeaderColumn, TableBody, TableRowColumn, RaisedButton,
  Card, CardText, CardHeader, Drawer, Dialog, FlatButton, IconButton, Paper, TextField,
} from "material-ui";
import { red100 } from "material-ui/styles/colors";
import Editar from "material-ui/svg-icons/image/edit";
import Eliminar from "material-ui/svg-icons/action/delete";
import Getapp from "material-ui/svg-icons/action/get-app";
import Add from "./../../../images/nuevo.png";
import Mod from "./../../../images/modificar.png";
import Del from "./../../../images/eliminar.png";
import {
  OpenQuitarPrestacionSolicitud, QuitarPrestacionSolicitudSeleccionada, OpenModalEliminarBorrador,
  LimpiarSolicitud, getBorrador, pushDetallePaquete, GuardarSolicitudParametrizada, pushDetalleCaracteristicas, pushDetallePrestaciones,
  updateSolicitudsync, UpdateIdSolicitud, UpdateStatusBorrador, deletePrestacionesBorrador, OpenSolicitudEnviada,
  sendToHomologador,
  PrestacionesToHomologador,
  IdSolicitudForHomologador,
  IdSolicitudHom,
  nuevaSolicitud
} from "./actions";
import { isNull } from "util";
import store from "../../../config/store";

import {
  deleteBorrador, ValidarPrestacionesSolicitudEnCurso,
} from "../FiltroBusquedaPQ/actions";

import SolicitudEditarCreacion from "../SolicitudEditarCreacion/view";
import { OpenSolicitudEditarCreacion } from "../SolicitudEditarCreacion/actions";
import SolicitudEditarEliminacion from "../SolicitudEditarEliminacion/view";
import { OpenSolicitudEditarEliminacion } from "../SolicitudEditarEliminacion/actions";
import SolicitudEditarModificacion from "../SolicitudEditarModificacion/view";
import { OpenSolicitudEditarModificacion } from "../SolicitudEditarModificacion/actions";
import { ErrorSnacktOpen } from "../../ErrorSnack/actions";
import styles from "../../styles/styles";
import TablePaginationCustom from "../../TablePagination/view";
import { DialogGeneric } from "../../Global/actions";
import { PermiteReplicarSolicitud } from "../ReplicarSolicitud/actions";
import ReplicarSolicitud from "../ReplicarSolicitud/view";
import urlHelper from "../../../helpers/urlHelper";

class GrillaSolicitudPQ extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalEnviarSolicitud: false,
      observaciones: "",
    };
  }

  componentWillMount() { }

  ModalSolicitudReajuste = () => {
    urlHelper.RedirectTo("SolicitudesRealizadas");
  }

  CloseQuitarPrestacionSolicitud = () => {
    this.props.dispatch(OpenQuitarPrestacionSolicitud(false, null));
  }

  OpenQuitarPrestacionSolicitud = (idPaqueteEditar) => {
    this.props.dispatch(OpenQuitarPrestacionSolicitud(true, idPaqueteEditar));
  }

  QuitarPrestacionSolicitudSeleccionada = () => {
    this.props.CambiosSinGuardar(true);
    this.props.dispatch(QuitarPrestacionSolicitudSeleccionada());
    this.props.dispatch(OpenQuitarPrestacionSolicitud(false, null));
  }

  CloseModalEliminarBorrador = () => {
    this.props.dispatch(OpenModalEliminarBorrador(false));
  }

  mostrarModalEnviarSolicitud = () => {
    this.setState({ modalEnviarSolicitud: !this.state.modalEnviarSolicitud });
    this.props.dispatch(nuevaSolicitud(null));
  }

  modificarObservaciones = (event) => {
    this.setState({ observaciones: event.target.value });
  }

  openModalSolicitudEnviada = () => {
    this.props.dispatch(PermiteReplicarSolicitud());
    this.props.dispatch(OpenSolicitudEnviada(true));
  }

  OpenModalEliminarBorrador = () => {
    this.props.dispatch(OpenModalEliminarBorrador(true));
  }

  validarSolicitud(option) {
    switch (option) {
      case 1: // Enviar Solicitud
        this.mostrarModalEnviarSolicitud();
        if (!this.props.prestacionesSolicitud || this.props.prestacionesSolicitud.length === 0) {
          this.props.dispatch(ErrorSnacktOpen("Solicitud No Enviada | Enviar Solicitud"));
        } /*else if (this.props.ENV.ENVIAR_SOLICITUD_CUANDO_EXISTE_EN_CURSO) {
          this.guardarSolicitud();
        } */else {
          this.props.dispatch(nuevaSolicitud(true));
          this.props.dispatch(ValidarPrestacionesSolicitudEnCurso(null, this.guardarSolicitud));
        }
        break;
      /*case 2: // Eliminar Borrador
        if (!this.props.prestacionesSolicitud || this.props.prestacionesSolicitud.length === 0) {
          this.props.dispatch(ErrorSnacktOpen("Solicitud No Enviada | Eliminar Borrador"));
        } else {
          this.OpenModalEliminarBorrador();
        }
        break;
      case 3: // Guardar Borrador
        if (!this.props.prestacionesSolicitud || this.props.prestacionesSolicitud.length === 0) {
          this.props.dispatch(ErrorSnacktOpen("Solicitud No Enviada | Guardar Borrador"));
        } else {
          this.GuardarBorrador();
        }
        break;*/
      default:
    }
  }

  guardarSolicitud = async () => {
    const { REACT_APP_REAJUSTAR_ARANCEL_FECHA_VIGENCIA_MINIMA: fechaVigenciaPrestador } = this.props.ENV;
    let validaFechaVigencia = true;
    let validaFechaFinVigencia = true;
    const dateMin = new Date(Date.now());
    dateMin.setDate(dateMin.getDate() + +fechaVigenciaPrestador);
    dateMin.setHours(0, 0, 0, 0);

    const globalState = store.getState().global;

    let listaUsuarios = "";
    let numNuevas = 0;
    let IdEstadoProceso = 14;
    let IdEstadoSolicitudWF = 38;
    const IdEstadoSolicitud = 8; // --8: SolicitudEnviada
    const IdTipoModificacionSolicitud = 71; // --71: Actualizar Paquete

    if (this.props.prestacionesSolicitud.length > 0) {
      //for (let i = 0; i < this.props.prestacionesSolicitud.length; i++) {
      this.props.prestacionesSolicitud.forEach((p) => {
        this.props.dispatch(GuardarSolicitudParametrizada(
          this.props.rutPrestador, this.props.rutInstitucion, this.props.isapre,
          IdEstadoSolicitud, IdTipoModificacionSolicitud, IdEstadoProceso, IdEstadoSolicitudWF,
          this.state.observaciones, listaUsuarios, async IdSolicitud => {
            let FinVig = null;
            let FechaFinVigencia = null;
            let InicioVig = null;
            let newInicioVig = null;
            let paqueteEditarDetalle = {};
            let paqueteCaractDetalle = [];
            let paquetePrestacionesDetalle = [];

            if (p.paqueteEditarMod != null) {
              if (p.fechaInicioMod) {
                InicioVig = new Date(p.fechaInicioMod);
                newInicioVig = `${InicioVig.getDate()}/${InicioVig.getMonth() + 1}/${InicioVig.getFullYear()} 00:00:00`;
              }
              if (p.paqueteEditarMod.PAQU_TERMINO_VIGENCIA) {
                FinVig = new Date(p.paqueteEditarMod.PAQU_TERMINO_VIGENCIA);
                FechaFinVigencia = `${FinVig.getDate()}/${FinVig.getMonth() + 1}/${FinVig.getFullYear()} 00:00:00`;
                newInicioVig = null;
              }

              paqueteEditarDetalle = {
                PAQU_CODIGO: p.paqueteEditarMod.PAQU_CODIGO,
                PAQU_INICIO_VIGENCIA: newInicioVig,
                PAQU_TERMINO_VIGENCIA: FechaFinVigencia,
                PAQU_DESCRIPCION: p.paqueteEditarMod.PAQU_DESCRIPCION,
                PRTA_NRUT_INSTITUCION: p.paqueteEditar.PRTA_NRUT_INSTITUCION,
                PRTA_NSECUEN_INSTITUCION: p.paqueteEditar.PRTA_NSECUEN_INSTITUCION,
                PAQU_CODIGO_PRESTADOR: p.paqueteEditarMod.PAQU_CODIGO_PRESTADOR,
                PAQU_DESC_PRESTADOR: p.paqueteEditarMod.PAQU_DESC_PRESTADOR,
                PRES_CCOD_INTERV_PRES: p.paqueteEditarMod.PRES_CCOD_INTERV_PRES,
                PRES_CCOD_INTERV: p.paqueteEditarMod.PRES_CCOD_INTERV,
                PAAT_CCOD_OLD: p.paqueteEditarMod.PAAT_CCOD_OLD,
                PRES_TDESC_INTERV_PRES: p.paqueteEditarMod.PRES_TDESC_INTERV_PRES,
                ID_PAQUETE: p.paqueteEditarMod.ID_PAQUETE,
                ISAP_CEMPRESA: this.props.isapre,
                IDSOLICITUD: IdSolicitud,
                MODIFICA_INFO: "S",
              };
              this.props.dispatch(pushDetallePaquete(paqueteEditarDetalle));
            }
            if (p.paqueteEditarMod === null) {
              if (p.fechaInicioMod) {
                InicioVig = new Date(p.fechaInicioMod);
                newInicioVig = `${InicioVig.getDate()}/${InicioVig.getMonth() + 1}/${InicioVig.getFullYear()} 00:00:00`;
              }

              paqueteEditarDetalle = {
                PAQU_CODIGO: p.paqueteEditar.PAQU_CODIGO,
                PAQU_INICIO_VIGENCIA: newInicioVig,
                PAQU_TERMINO_VIGENCIA: null,
                PAQU_DESCRIPCION: p.paqueteEditar.PAQU_DESCRIPCION,
                PRTA_NRUT_INSTITUCION: p.paqueteEditar.PRTA_NRUT_INSTITUCION,
                PRTA_NSECUEN_INSTITUCION: p.paqueteEditar.PRTA_NSECUEN_INSTITUCION,
                PAQU_CODIGO_PRESTADOR: p.paqueteEditar.PAQU_CODIGO_PRESTADOR,
                PAQU_DESC_PRESTADOR: p.paqueteEditar.PAQU_DESC_PRESTADOR,
                PRES_CCOD_INTERV_PRES: p.paqueteEditar.PRES_CCOD_INTERV_PRES,
                PRES_CCOD_INTERV: p.paqueteEditar.PRES_CCOD_INTERV,
                PAAT_CCOD_OLD: p.paqueteEditar.PAAT_CCOD_OLD,
                PRES_TDESC_INTERV_PRES: p.paqueteEditar.PRES_TDESC_INTERV_PRES,
                ID_PAQUETE: p.paqueteEditar.ID_PAQUETE,
                ISAP_CEMPRESA: this.props.isapre,
                IDSOLICITUD: IdSolicitud,
                MODIFICA_INFO: "N",
              };
              this.props.dispatch(pushDetallePaquete(paqueteEditarDetalle));
            }
            if (p.caractPaqueteMod != null) {
              p.caractPaqueteMod.forEach((c) => {
                paqueteCaractDetalle.push({
                  PAQU_CODIGO: p.paqueteEditar.PAQU_CODIGO,
                  Tipo: c.Tipo,
                  Descripcion: c.Descripcion,
                  ID_PAQUETE: p.paqueteEditar.ID_PAQUETE,
                  ISAP_CEMPRESA: this.props.isapre,
                  IDSOLICITUD: IdSolicitud
                });
              });
              paqueteCaractDetalle.forEach((detalle) => {
                this.props.dispatch(pushDetalleCaracteristicas(detalle));
              });
            }
            if (p.prestacionesMod != null) {
              p.prestacionesMod.forEach((d) => {
                paquetePrestacionesDetalle.push({
                  PAQU_CODIGO: p.paqueteEditar.PAQU_CODIGO,
                  ID_PAQUETE: d.ID_PAQUETE,
                  IDSOLICITUD: IdSolicitud,
                  BONO_RUT: d.BONO_RUT,
                  CANT_PRES: d.CANT_PRES,
                  COD_PRES_ISAP: d.COD_PRES_ISAP,
                  COD_PRES_PREST: d.COD_PRES_PREST,
                  COD_PROF: d.COD_PROF,
                  GLOSA_PRES_PREST: d.GLOSA_PRES_PREST,
                  ITEM_IMED: d.ITEM_IMED,
                  MEDICO_U_HOTELERIA: d.MEDICO_U_HOTELERIA,
                  MONTO_UNITARIO: d.MONTO_UNITARIO,
                  TIPO_ATENCION: d.TIPO_ATENCION,
                  UNIDAD: d.UNIDAD,
                  ISAP_CEMPRESA: this.props.isapre,
                  GRBA_CCOD: d.GRBA_CCOD,
                });
              });
              paquetePrestacionesDetalle.forEach((detalle) => {
                this.props.dispatch(pushDetallePrestaciones(detalle));
              });
            }

          }));
      });
      this.openModalSolicitudEnviada();
      this.props.dispatch(ErrorSnacktOpen("Solicitud Enviada"));
      this.props.dispatch(nuevaSolicitud(null));
    }
  }


  GuardarBorrador = () => {
    /*const { REACT_APP_REAJUSTAR_ARANCEL_FECHA_VIGENCIA_MINIMA: fechaVigenciaPrestador } = this.props.ENV;

    let validaFechaVigencia = true;
    let validaFechaFinVigencia = true;
    const dateMin = new Date(Date.now());
    dateMin.setDate(dateMin.getDate() + fechaVigenciaPrestador);
    dateMin.setHours(0, 0, 0, 0);
    for (let i = 0; i < this.props.prestacionesSolicitud.length; i += 1) {
      if (this.props.prestacionesSolicitud[i].INICIO_VIG != null) {
        const InicioVig = new Date(this.props.prestacionesSolicitud[i].INICIO_VIG);
        InicioVig.setHours(0, 0, 0, 0);
        if (InicioVig < dateMin && this.props.prestacionesSolicitud[i].COD_OPERACION !== "2") {
          validaFechaVigencia = false;
        }
      }
      if (this.props.prestacionesSolicitud[i].FECHA_FIN_VIG != null) {
        const FinVig = new Date(this.props.prestacionesSolicitud[i].FECHA_FIN_VIG);
        FinVig.setHours(0, 0, 0, 0);
        if (FinVig < dateMin && this.props.prestacionesSolicitud[i].COD_OPERACION === "2") {
          validaFechaFinVigencia = false;
        }
      }
    }

    if (!validaFechaVigencia) {
      this.props.dispatch(DialogGeneric(
        true,
        "Existen errores en las fecha de vigencia. Favor validar"
      ));
      return;
    }
    if (!validaFechaFinVigencia) {
      this.props.dispatch(DialogGeneric(
        true,
        "Existen errores en las fecha de fin vigencia. Favor validar"
      ));
      return;
    }

    if (this.props.idSolicitud == null) {
      this.props.dispatch(getBorrador(this.props.rutPrestador, this.props.rutInstitucion, this.props.isapre, saveDetails));
      const props = {
        ...this.props,
      };

      function saveDetails(IdSolicitud) {
        const prestsToSend = [];

        props.prestacionesSolicitud.forEach((prestacion) => {
          let finVigencia = null;
          let InicioVig = null;
          let newInicioVig = null;

          if (!isNull(prestacion.FECHA_FIN_VIG) && typeof prestacion.FECHA_FIN_VIG !== "undefined") {
            finVigencia = new Date(prestacion.FECHA_FIN_VIG);
            finVigencia = `${finVigencia.getDate()}/${finVigencia.getMonth() + 1}/${finVigencia.getFullYear()} 00:00:00`;
          }

          if (!isNull(prestacion.INICIO_VIG) && typeof prestacion.INICIO_VIG !== "undefined") {
            InicioVig = new Date(prestacion.INICIO_VIG);
            newInicioVig = `${InicioVig.getDate()}/${InicioVig.getMonth() + 1}/${InicioVig.getFullYear()} 00:00:00`;
          }

          if (typeof prestacion.INICIO_VIG === "undefined" && typeof prestacion.INICIO_VIG_PREV !== "undefined" && prestacion.INICIO_VIG_PREV != null) {
            InicioVig = new Date(prestacion.INICIO_VIG_PREV);
            newInicioVig = `${InicioVig.getDate()}/${InicioVig.getMonth() + 1}/${InicioVig.getFullYear()} 00:00:00`;
          }

          const CodPertenenciaFonasa = prestacion.PERTENENCIA_FONASA || 0;

          const prestacionDetalle = {
            CentroAtencionSecuencia: prestacion.SECUENCIA,
            CodigoFonasa: prestacion.CODIGO_FONASA,
            CodigoPrestacionIsapre: prestacion.COD_ISAPRE,
            CodigoPrestacionPrestador: prestacion.COD_PRESTADOR,
            CodigoProfesionalIsapre: prestacion.PROF_CCOD,
            CodigoProfesionalPrestador: prestacion.PROF_CCOD,
            FechaInicioVigenciaAnterior: newInicioVig,
            FechaInicioVigenciaPosterior: newInicioVig,
            FechaTerminoVigenciaAnterior: finVigencia,
            FechaTerminoVigenciaPosterior: finVigencia,
            GlosaGrupoPrestacionPrestador: prestacion.GLOSA_GRUPOPRESTADOR,
            GlosaPrestacionPrestador: prestacion.GLOSA_CODPRESTADOR,
            GrupoPrestacionIsapre: 0,
            GrupoPrestacionPrestador: 0,
            Guarismo: prestacion.GUARISMO,
            IdPrestacionIsapre: prestacion.IDPRESTACION,
            IdSolicitud,
            IdTipoAccionPrestacion: prestacion.COD_OPERACION,
            ItemImed: prestacion.ITEM_IMED,
            PertenenciaFonasa: CodPertenenciaFonasa,
            Arancel: prestacion.RUTARANCEL,
            TipoAtencion: prestacion.TIPO_ATENCION,
            UnidadAnterior: prestacion.UNIDAD_ANT,
            UnidadPosterior: prestacion.UNIDAD,
            ValorAnterior: prestacion.VALOR_ANT,
            ValorPosterior: prestacion.VALOR,
          };
          prestsToSend.push(prestacionDetalle);
        });

        props.dispatch(pushDetalleSolicitud({ prestsToSend, saveBorrador: true }));
      }
    } else {
      // this.props.dispatch(deletePrestacionesBorrador(this.props.idSolicitud));
      const prestsToSend = [];

      this.props.prestacionesSolicitud.forEach((prestacion) => {
        let finVigencia = null;
        let InicioVig = null;
        let newInicioVig = null;

        if (!isNull(prestacion.FECHA_FIN_VIG) && typeof prestacion.FECHA_FIN_VIG != "undefined") {
          finVigencia = new Date(prestacion.FECHA_FIN_VIG);
          finVigencia = `${finVigencia.getDate()}/${finVigencia.getMonth() + 1}/${finVigencia.getFullYear()} 00:00:00`;
        }

        if (!isNull(prestacion.INICIO_VIG) && typeof prestacion.INICIO_VIG !== "undefined") {
          InicioVig = new Date(prestacion.INICIO_VIG);
          newInicioVig = `${InicioVig.getDate()}/${InicioVig.getMonth() + 1}/${InicioVig.getFullYear()} 00:00:00`;
        }

        if (typeof prestacion.INICIO_VIG === "undefined" && typeof prestacion.INICIO_VIG_PREV !== "undefined" && prestacion.INICIO_VIG_PREV != null) {
          InicioVig = new Date(prestacion.INICIO_VIG_PREV);
          newInicioVig = `${InicioVig.getDate()}/${InicioVig.getMonth() + 1}/${InicioVig.getFullYear()} 00:00:00`;
        }

        const CodPertenenciaFonasa = prestacion.PERTENENCIA_FONASA || 0;

        console.log("[PRESTACION UPDATE]:", prestacion);

        const prestacionDetalle = {
          CentroAtencionSecuencia: prestacion.SECUENCIA,
          CodigoFonasa: prestacion.CODIGO_FONASA,
          CodigoPrestacionIsapre: prestacion.COD_ISAPRE,
          CodigoPrestacionPrestador: prestacion.COD_PRESTADOR,
          CodigoProfesionalIsapre: prestacion.PROF_CCOD,
          CodigoProfesionalPrestador: prestacion.PROF_CCOD,
          FechaInicioVigenciaAnterior: newInicioVig,
          FechaInicioVigenciaPosterior: newInicioVig,
          FechaTerminoVigenciaAnterior: finVigencia,
          FechaTerminoVigenciaPosterior: finVigencia,
          GlosaGrupoPrestacionPrestador: prestacion.GLOSA_GRUPOPRESTADOR,
          GlosaPrestacionPrestador: prestacion.GLOSA_CODPRESTADOR,
          GrupoPrestacionIsapre: 0,
          GrupoPrestacionPrestador: 0,
          Guarismo: prestacion.GUARISMO,
          IdPrestacionIsapre: prestacion.IDPRESTACION,
          IdSolicitud: this.props.idSolicitud,
          IdDetallePrestacion: prestacion.IDDETALLEPRESTACION,
          IdTipoAccionPrestacion: prestacion.COD_OPERACION,
          PertenenciaFonasa: CodPertenenciaFonasa,
          Arancel: prestacion.RUTARANCEL,
          TipoAtencion: prestacion.TIPO_ATENCION,
          UnidadAnterior: prestacion.UNIDAD_ANT,
          UnidadPosterior: prestacion.UNIDAD,
          ValorAnterior: typeof prestacion.VALOR_ANT !== "undefined" ? prestacion.VALOR_ANT : null,
          ValorPosterior: prestacion.VALOR,
          Vigencia: prestacion.VIGENCIA ? prestacion.VIGENCIA : '1',
        };
        prestsToSend.push(prestacionDetalle);
      });

      this.props.dispatch(pushDetalleSolicitud({ prestsToSend, updateBorrador: true }));
    }
    this.props.dispatch(ErrorSnacktOpen("Borrador Guardado"));
  */}


  EliminarBorradorSolicitud = () => {
    this.props.dispatch(deleteBorrador(this.props.idSolicitud, this.props.rutPrestador, this.props.rutInstitucion, this.props.isapre));
    this.props.dispatch(LimpiarSolicitud());
    this.props.dispatch(OpenModalEliminarBorrador(false));
  }


  OpenEditarPrestacionSolicitud(codOperacion, rowGuid) {
    const detallePrestacion = this.props.prestacionesSolicitud.filter((p) => p.GUID === rowGuid)[0];
    switch (codOperacion) {
      case 1:
      case "1":
        this.props.dispatch(OpenSolicitudEditarCreacion(true, detallePrestacion));
        break;
      case 2:
      case "2":
        this.props.dispatch(OpenSolicitudEditarEliminacion(true, detallePrestacion));
        break;
      case 3:
      case "3":
        this.props.dispatch(OpenSolicitudEditarModificacion(true, detallePrestacion));
        break;
      default:
        console.log(`OPERACION NO ENCONTRADA: ${codOperacion}`); break;
    }
  }

  SelIcon = (operacion, index) => {
    const boton = [];
    if (operacion.toString() === "1") {
      boton.push((
        <img
          alt="Tipo Doc"
          src={Add}
          className="img-fluid"
          height={25}
          width={45}
          key={`tablaRowGrillaSolicitudPrestaciones_imgadd_${index}`}
        />
      ));
    }
    if (operacion.toString() === "3") {
      boton.push((
        <img
          alt="Tipo Doc"
          src={Mod}
          className="img-fluid"
          height={25}
          width={45}
          key={`tablaRowGrillaSolicitudPrestaciones_imgmod_${index}`}
        />
      ));
    }
    if (operacion.toString() === "2") {
      boton.push((
        <img
          alt="Tipo Doc"
          src={Del}
          className="img-fluid"
          height={25}
          width={45}
          key={`tablaRowGrillaSolicitudPrestaciones_imgdel_${index}`}
        />
      ));
    }
    return boton;
  }

  render() {
    const { REACT_APP_REAJUSTAR_ARANCEL_FECHA_VIGENCIA_MINIMA: fechaVigenciaPrestador } = this.props.ENV;

    const menuListprestaciones = [];
    const dateMin = new Date(Date.now());
    dateMin.setDate(dateMin.getDate() + fechaVigenciaPrestador);
    dateMin.setHours(0, 0, 0, 0);

    let fechaFin = null;

    //console.log('PRESTACIONES:', this.props.prestacionesSolicitud);

    this.props.prestacionesSolicitud.forEach((row, index) => {
      let operaciones = [];
      if (row.paqueteEditarMod != null) {
        if (row.paqueteEditarMod.PAQU_TERMINO_VIGENCIA != null) {
          fechaFin = (new Date(row.paqueteEditarMod.PAQU_TERMINO_VIGENCIA)).toLocaleDateString("en-GB", { timeZone: "UTC" })
        }
      }
      //console.log(row)

      if (row.paqueteEditarMod != null) {
        operaciones.push(" INFORMACIÓN");
      }
      if (row.caractPaqueteMod != null) {
        operaciones.push(" CARACTERÍSTICAS");
      }
      if (row.prestacionesMod != null) {
        operaciones.push(" PRESTACIONES");
      }

      menuListprestaciones.push((
        <TableRow
          //style={errorVigencia ? { backgroundColor: red100 } : null}
          key={`tablaRowGrillaSolicitudPrestaciones_${index}`}
        >
          <TableRowColumn style={styles.datoTablaBusquedaP6}>{row.paqueteEditar.PAQU_CODIGO}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP6}>{row.paqueteEditar.ARANCEL}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP6}>{row.paqueteEditar.PAQU_CODIGO_PRESTADOR}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP6}>{row.paqueteEditar.PRES_CCOD_INTERV}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP6}>{row.paqueteEditar.PRES_TDESC_INTERV_PRES}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaPP2}>{operaciones.toString()}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP6}>{row.fechaInicioMod != null ? (new Date(row.fechaInicioMod)).toLocaleDateString("en-GB", { timeZone: "UTC" }) : null}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP6}>{fechaFin}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaBusquedaP6}>

            {/*<IconButton
              key={`tablaRowGrillaSolicitudPrestaciones_btnedit_${index}`}
              iconStyle={styles.svgStyleResultado}
              style={styles.iconStyleResultado}

            >
              <Editar
                key={`tablaRowGrillaSolicitudPrestaciones_btnedit_img_${index}`}
                onClick={() => this.OpenEditarPrestacionSolicitud(row.idPaqueteEditar)}
              />
            </IconButton>*/}
            <IconButton
              key={`tablaRowGrillaSolicitudPrestaciones_btnedel_${index}`}
              iconStyle={styles.svgStyleResultado}
              style={styles.iconStyleResultado}
            >
              <Eliminar
                key={`tablaRowGrillaSolicitudPrestaciones_btnedel_img_${index}`}
                onClick={() => this.OpenQuitarPrestacionSolicitud(row.idPaqueteEditar)}

              />
            </IconButton>
          </TableRowColumn>
        </TableRow>
      ));
    });

    let numNuevas = 0;
    let numModificaciones = 0;
    let numEliminaciones = 0;
    /*if (this.props.prestacionesSolicitud) {
      numNuevas = this.props.prestacionesSolicitud.filter((p) => p.COD_OPERACION === "1").length;
      numEliminaciones = this.props.prestacionesSolicitud.filter((p) => p.COD_OPERACION === "2").length;
      numModificaciones = this.props.prestacionesSolicitud.filter((p) => p.COD_OPERACION === "3").length;
    }*/

    const actionsModalQuitar = [
      <FlatButton
        label="Cancelar"
        primary
        onClick={this.CloseQuitarPrestacionSolicitud}
      />,
      <FlatButton
        label="Aceptar"
        primary
        onClick={this.QuitarPrestacionSolicitudSeleccionada}
      />,
    ];

    const actionsModalEliminarBorrador = [
      <FlatButton
        label="Cancelar"
        primary
        onClick={this.CloseModalEliminarBorrador}
      />,
      <FlatButton
        label="Aceptar"
        primary
        onClick={this.EliminarBorradorSolicitud}
      />,
    ];

    /* if (this.props.idSolicitud != null && this.props.cargandoBorrador === false) {

    } */

    const actionsEnviarSolicitud = [
      <FlatButton
        label="Si, enviar"
        primary
        onClick={() => this.validarSolicitud(1)}
      />,
      <FlatButton
        label="No"
        primary
        onClick={this.mostrarModalEnviarSolicitud}
      />,
    ];

    return (
      <div>
        <div style={{ padding: "5px" }}>
          <Card
            initiallyExpanded
            zDepth={0}
          >
            <CardHeader
              actAsExpander
              showExpandableButton
              style={{
                paddingTop: "0px", paddingBottom: "0px", maxWidth: "990px",
              }}
            >
              <div style={styles.h1}>Paquetes a modificar</div>
            </CardHeader>
            <CardText
              expandable
              style={{
                paddingTop: "0px", paddingBottom: "0px", maxWidth: "990px", overflow: "auto",
              }}
            >
              {(!this.props.prestacionesSolicitud || this.props.prestacionesSolicitud.length === 0) ?
                <span style={{ textAlign: "center" }}>No existen modificaciones</span>
                :
                <div>
                  <div style={{ overflowX: "auto" }}>
                    <div style={{ width: "fit-content", overflow: "hidden" }}>
                      <Table
                        key="tablaGrillaSolicitudPrestaciones"
                        fixedHeader
                        selectable={false}
                        style={{ overflow: "hidden" }}
                      >
                        <TableHeader adjustForCheckbox={false} displaySelectAll={false} >
                          <TableRow selectable={false}>
                            <TableHeaderColumn style={styles.tituloTablaBusquedaP6}>Paquete</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaBusquedaP6}>Tipo Arancel</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaBusquedaP6}>Código<br />Paquete Prestador</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaBusquedaP6}>Código<br />Intervención Principal</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaBusquedaP6}>Glosa<br />Intervención</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaBusquedaP2}>Tipo de<br />Operación</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaBusquedaP6}>Fecha<br />Inicio Vigencia</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaBusquedaP6}>Fecha<br />Fin Vigencia</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaBusquedaP6}>Eliminar</TableHeaderColumn>{/*Falta Editar*/}
                          </TableRow>
                        </TableHeader>
                        <TableBody
                          id="tablaBodyGrillaSolicitudPrestaciones"
                          deselectOnClickaway={false}
                          displayRowCheckbox={false}
                          stripedRows
                        >
                          {menuListprestaciones}
                        </TableBody>
                      </Table>
                    </div>
                  </div>
                  <TablePaginationCustom
                    key={`pag_tablaBodyGrillaSolicitudPrestaciones_${menuListprestaciones.length}`}
                    rowsPerPageDefault={5} // [5,10,15,20,25]
                    totalRows={menuListprestaciones.length}
                    pageDefault={1}
                    idTableBody="tablaBodyGrillaSolicitudPrestaciones"
                    showRowsPerPage={false}
                    labelStyleBtnPage={{ fontSize: "11px" }}
                    overlayStyleBtnPage={{ borderRadius: 20 }}
                    rippleStyleBtnPage={{ borderRadius: 20 }}
                    buttonStyleBtnPage={{ borderRadius: 20 }}
                    styleBtnPage={{
                      paddingLeft: 0,
                      paddingRight: 0,
                      paddingTop: 0,
                      paddingBottom: 0,
                      height: 25,
                      width: "45px",
                      minWidth: "45px",
                      borderRadius: 20,
                      marginRight: 5,
                    }}

                    labelStyleRowsPerPage={styles.h4}
                    underlineStyleRowsPerPage={styles.underlineSelectField}
                    iconStyleRowsPerPage={styles.iconSelectField}
                    menuItemStyleRowsPerPage={styles.menuItemStyleSelectField}
                    selectedMenuItemStyleRowsPerPage={styles.selectedMenuItemSelectField}
                    styleRowsPerPage={styles.selectFiledStyle}
                  />
                </div>
              }
            </CardText>
          </Card>
        </div>

        {/*<div
          className="row"
          style={{
            paddingLeft: 10, marginLeft: 40, marginRight: 40, backgroundColor: "#e5e5e5",
          }}
        >
          <div className="col-xs-2" style={{ marginRight: 50 }} >
            <span style={styles.contadoresStyle}>Ingresos: {numNuevas} |</span>
          </div>
          <div className="col-xs-2" style={{ marginRight: 20 }} >
            <span style={styles.contadoresStyle}>Modificaciones: {numModificaciones} |</span>
          </div>
          <div className="col-xs-2" >
            <span style={styles.contadoresStyle}>Eliminaciones: {numEliminaciones}</span>
          </div>
        </div>*/}

        <div
          className="row text-right"
          style={{
            textAlign: "right", paddingLeft: 0, marginLeft: 40, marginTop: 20, marginBottom: 20, width: 950,
          }}
        >
          <div style={{
            display: "none"
          }}
          >V1.11</div>
          <div className="col-xs-12" style={{ textAlign: "right", width: 950 }}>
            {/*this.props.ENV.DESHABILITAR_BORRADOR ?
              null
              :
              <RaisedButton
                label="Eliminar Borrador"
                onClick={() => this.validarSolicitud(2)}

                backgroundColor="#fff"
                labelPosition="before"
                overlayStyle={{ borderRadius: 5 }}
                labelStyle={{
                  fontSize: "11px", color: "#757575", paddingLeft: 10, paddingRight: 5, top: -3,
                }}
                style={{ width: "190px", borderRadius: 5 }}
                buttonStyle={{ border: "2px solid #C3C3C3", borderRadius: 5 }}
                icon={<Eliminar />}
                disabled={!this.props.prestacionesSolicitud || this.props.prestacionesSolicitud.length === 0}
              />
            }
            {this.props.ENV.DESHABILITAR_BORRADOR ?
              null
              :
              <RaisedButton
                onClick={() => this.validarSolicitud(3)}
                label="Guardar Borrador"
                backgroundColor="#fff"
                labelPosition="before"
                overlayStyle={{ borderRadius: 5 }}
                labelStyle={{
                  fontSize: "11px", color: "#00A100", paddingLeft: 10, paddingRight: 5, top: -3,
                }}
                style={{ width: "190px", borderRadius: 5, marginLeft: 20 }}
                buttonStyle={{ border: "2px solid #C3C3C3", borderRadius: 5 }}
                icon={<Getapp />}
                disabled={!this.props.prestacionesSolicitud || this.props.prestacionesSolicitud.length === 0}
              />
              */}

            <RaisedButton
              label="Enviar Solicitud"
              secondary
              labelStyle={{ fontSize: "11px" }}
              onClick={this.mostrarModalEnviarSolicitud}
              overlayStyle={{ borderRadius: 5 }}
              rippleStyle={{ borderRadius: 5 }}
              style={{ width: "150px", borderRadius: 5, marginLeft: 20 }}
              buttonStyle={{ borderRadius: 5 }}
              disabled={!this.props.prestacionesSolicitud || this.props.prestacionesSolicitud.length === 0 || this.props.creando != null}
            />
            <Dialog
              actions={actionsEnviarSolicitud}
              modal
              open={this.state.modalEnviarSolicitud}
              style={{ width: "1000px", fontSize: "13px" }}
            >
              <div>
                ¿Confirma que desea enviar la solicitud?<br />
                <span style={{ color: "black" }}>(Si necesita enviarnos observaciones, por favor indíquelas a continuación)</span>
              </div>
              <TextField
                name="observaciones"
                id="observaciones"
                hintStyle={{ top: "3px", left: "3px", color: "rgba(0, 0, 0, 0.4)" }}
                underlineStyle={styles.underlineSelectField}
                inputStyle={styles.h4}
                value={this.state.observaciones}
                onChange={this.modificarObservaciones}
                style={styles.textFieldSolicitudObservacion}
                multiLine
                rows={4}
                rowsMax={4}
                maxLength={1000}
              />
            </Dialog>
          </div>
        </div>

        <div>
          <Drawer
            width="100%"
            openSecondary
            open={this.props.modalSolicitudEditarCreacion}
            docked={false}
          >
            {this.props.modalSolicitudEditarCreacion ?
              <SolicitudEditarCreacion />
              : null}
          </Drawer>
          <Drawer
            width="100%"
            openSecondary
            open={this.props.modalSolicitudEditarEliminacion}
            docked={false}
          >
            {this.props.modalSolicitudEditarEliminacion ?
              <SolicitudEditarEliminacion CambiosSinGuardar={this.props.CambiosSinGuardar} />
              : null}
          </Drawer>
          <Drawer
            width="100%"
            openSecondary
            open={this.props.modalSolicitudEditarModificacion}
            docked={false}
          >
            {this.props.modalSolicitudEditarModificacion ?
              <SolicitudEditarModificacion CambiosSinGuardar={this.props.CambiosSinGuardar} />
              : null}
          </Drawer>

          <Dialog
            key="modalQuitarPrestacionSolicitud"
            actions={actionsModalQuitar}
            modal
            open={this.props.modalQuitarPrestacionSolicitud}
            style={{ width: "700px", fontSize: "13px" }}
          >
            Se eliminará el Paquete seleccionado de la grilla de solicitudes.
          </Dialog>

          <Dialog
            key="modalEliminarBorradorSolicitud"
            actions={actionsModalEliminarBorrador}
            modal
            open={this.props.modalEliminarBorrador}
            style={{ width: "700px", fontSize: "13px" }}
          >
            Se eliminarán todas las prestaciones ({numNuevas + numEliminaciones + numModificaciones}) de la solicitud
          </Dialog>

          <Dialog
            key="modalGeneric"
            actions={[
              <FlatButton
                label="Aceptar"
                primary
                onClick={() => this.props.dispatch(DialogGeneric(false, null))}
              />,
            ]}
            modal
            open={this.props.dialogGeneric.open}
            title={
              <div>
                <div style={{ float: "right" }}>
                  <IconButton onClick={() => this.props.dispatch(DialogGeneric(false, null))} >
                    <i className="material-icons" style={{ color: "#ffffff" }}>close</i>
                  </IconButton>
                </div>
              </div>
            }
          >
            {this.props.dialogGeneric.contenido}
          </Dialog>

        </div>
        <Drawer
          width="100%"
          openSecondary
          open={this.props.modalSolicitudEnviada}
          docked={false}
        >
          {(this.props.modalSolicitudEnviada) ?
            <div style={{ width: "100%", fontSize: "13px" }}>
              <Card zDepth={0} style={{ padding: 0 }}>
                <CardText style={{ paddingBottom: 0 }}>
                  <div className="row" style={{ paddingBottom: 0 }}>
                    <div className="col-12">
                      <Paper zDepth={1} rounded={false} width="100%" style={{ margin: "10px 0px", width: "100%", padding: "10px 5px" }} >
                        <div className="col-12" style={{ margin: 0, padding: 0 }}>
                          <div style={styles.h1}>Solicitud de Actualización de Paquete
                          </div>
                        </div>
                        <div className="col-5" style={{ margin: 0, padding: 0 }}>
                          <div className="row">
                            <div className="col-4" style={styles.tituloEnviarSolicitud}>
                              N°  solicitud
                            </div>
                            <div className="col-4" style={styles.datoEnviarSolicitud}>
                              {(this.props.idSolicitud).toString()}
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-4" style={styles.tituloEnviarSolicitud}>
                              {(this.props.IdSolicitudHomologador == null) ? null : 'N°  solicitud Homologador'}
                            </div>
                            <div className="col-4" style={styles.datoEnviarSolicitud}>
                              {(this.props.IdSolicitudHomologador == 0) ? '...Creando Solicitud' : this.props.IdSolicitudHomologador}
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-4" style={styles.tituloEnviarSolicitud}>
                              Fecha Solicitud
                            </div>
                            <div className="col-4" style={styles.datoEnviarSolicitud}>
                              {(new Date()).toLocaleDateString()}
                            </div>
                          </div>
                        </div>
                        <div className="col-5" style={{ margin: 0, padding: 0 }}>
                          <div className="row">
                            <div className="col-4" style={styles.tituloEnviarSolicitud}>
                              Tipo Solicitud
                            </div>
                            <div className="col-4" style={styles.datoEnviarSolicitud}>
                              Actualizar Paquete
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-4" style={styles.tituloEnviarSolicitud}>
                              Estado Solicitud
                            </div>
                            <div className="col-4" style={styles.datoEnviarSolicitud}>
                              Solicitud Enviada
                            </div>
                          </div>
                        </div>
                        <div className="col-12" style={{ margin: 0, padding: 0 }}>
                          <div style={styles.h3}>
                            La resolución de su solicitud será notificada vía electrónica a su email
                            de contacto. De igual forma podrá revisar lo solicitado y el estado de
                            su solicitud en el menú
                            <RaisedButton
                              label="Solicitudes Realizadas"
                              onClick={this.ModalSolicitudReajuste}
                              secondary
                              labelStyle={{ fontSize: "11px" }}
                              overlayStyle={{ borderRadius: 5 }}
                              rippleStyle={{ borderRadius: 5 }}
                              style={{ width: "190px", borderRadius: 5, marginLeft: 20 }}
                              buttonStyle={{ borderRadius: 5 }}
                            />
                          </div>
                        </div>
                      </Paper>
                    </div>
                    {/*console.log("this.props.prestadorPuedeReplicar: ", this.props.prestadorPuedeReplicar)}
                    {console.log("this.props: ", this.props)}
                    {(this.props.prestadorPuedeReplicar && this.props.IdSolicitudHomologador != 0) ?
                      <div className="col-12">
                        <Paper zDepth={1} rounded={false} width="100%" style={{ margin: "10px 0px", width: "100%", padding: "10px 5px" }} >
                          <ReplicarSolicitud />
                        </Paper>
                      </div>
                    : null*/}
                  </div>
                </CardText>
              </Card>
            </div>
            : null}
        </Drawer>
      </div>
    );
  }
}

GrillaSolicitudPQ.defaultProps = {
  rutInstitucion: null,
  rutPrestador: null,
  idSolicitud: null,
  cargandoBorrador: null,
};

GrillaSolicitudPQ.propTypes = {
  IdSolicitudForHomologador: PropTypes.number,
  prestacionesToHomologador: PropTypes.array,
  prestacionesSolicitud: PropTypes.array.isRequired,
  modalSolicitudEditarCreacion: PropTypes.bool.isRequired,
  modalSolicitudEditarEliminacion: PropTypes.bool.isRequired,
  modalSolicitudEditarModificacion: PropTypes.bool.isRequired,
  modalQuitarPrestacionSolicitud: PropTypes.bool.isRequired,
  modalEliminarBorrador: PropTypes.bool.isRequired,
  rutInstitucion: PropTypes.number,
  rutPrestador: PropTypes.number,
  isapre: PropTypes.string.isRequired,
  idSolicitud: PropTypes.any,
  IdSolicitudHomologador: PropTypes.number,
  dispatch: PropTypes.func.isRequired,
  CambiosSinGuardar: PropTypes.func.isRequired,
  modalSolicitudEnviada: PropTypes.bool.isRequired,
  dialogGeneric: PropTypes.any.isRequired,
  ENV: PropTypes.any.isRequired,
  cargandoBorrador: PropTypes.bool,
  prestadorPuedeReplicar: PropTypes.bool.isRequired,
  datosUsuario: PropTypes.object.isRequired,
  creando: PropTypes.number,
};

const mapStateToProps = (state) => ({
  IdSolicitudForHomologador: state.grillaSolicitudPQ.IdSolicitudForHomologador,
  prestacionesToHomologador: state.grillaSolicitudPQ.prestacionesToHomologador,
  prestacionesSolicitud: state.grillaSolicitudPQ.prestacionesSolicitud,
  modalSolicitudEditarCreacion: state.solicitudEditarCreacion.modalSolicitudEditarCreacion,
  modalSolicitudEditarEliminacion: state.solicitudEditarEliminacion.modalSolicitudEditarEliminacion,
  modalSolicitudEditarModificacion: state.solicitudEditarModificacion.modalSolicitudEditarModificacion,
  modalQuitarPrestacionSolicitud: state.grillaSolicitud.modalQuitarPrestacionSolicitud,
  modalEliminarBorrador: state.grillaSolicitud.modalEliminarBorrador,
  rutInstitucion: state.global.rutInstitucion,
  rutPrestador: state.global.rutPrestador,
  isapre: state.global.isapre,
  idSolicitud: state.grillaSolicitudPQ.idSolicitud,
  IdSolicitudHomologador: state.grillaSolicitud.IdSolicitudHomologador,
  cargandoBorrador: state.grillaSolicitud.cargandoBorrador,
  modalSolicitudEnviada: state.grillaSolicitud.modalSolicitudEnviada,
  dialogGeneric: state.global.dialogGeneric,
  ENV: state.global.ENV,
  prestadorPuedeReplicar: state.replicarSolicitud.prestadorPuedeReplicar,
  datosUsuario: state.global.datosUsuario,
  creando: state.grillaSolicitudPQ.creando,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(GrillaSolicitudPQ);
